var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"549294e6403f87eae20c8efa1c16b16f3572e057"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["anima-web-app@anima"]={id:"549294e6403f87eae20c8efa1c16b16f3572e057"};
      